import React from "react";

function Footer() {
  return (
    <footer>
      <div className="container">
        <div>© 2020 HIVE asbl</div>

        <img src="/images/logo/white.png" />
      </div>
    </footer>
  );
}

export default Footer;
